import React from "react";
import { NavLink } from "react-router-dom";
import { Home, Newspaper, Search, LayoutGrid, Mail } from "lucide-react";

const ITEMS = [
  { to: "/",         label: "Home",     Icon: Home,       end: true, testId: "mbn-home" },
  { to: "/latest",   label: "Latest",   Icon: Newspaper,              testId: "mbn-latest" },
  { to: "/search",   label: "Search",   Icon: Search,                 testId: "mbn-search" },
  { to: "/categories", label: "Topics", Icon: LayoutGrid,             testId: "mbn-categories" },
  { to: "/digest",   label: "Digest",   Icon: Mail,                   testId: "mbn-digest" },
];

export default function MobileBottomNav() {
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-40 md:hidden io-glass"
      style={{ background: "rgba(7,10,18,0.9)" }}
      data-testid="mobile-bottom-nav"
    >
      <div className="grid grid-cols-5">
        {ITEMS.map(({ to, label, Icon, end, testId }) => (
          <NavLink
            key={to} to={to} end={end}
            data-testid={testId}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-1 py-2.5 text-[10px] font-sans tracking-wide ${
                isActive ? "text-[var(--io-gold)]" : "text-[var(--io-text-2)]"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <Icon size={18} strokeWidth={isActive ? 2.2 : 1.6} />
                <span className="uppercase" style={{ letterSpacing: "0.12em" }}>{label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
